import { memo, useEffect, useState } from 'react';
import { AnimatePresence, motion, Transition, Variants } from 'framer-motion';

import { displayDuration, getDuration } from 'utils';
import { LiveWaveIcon } from 'components/Icon';

import styles from './LiveEvent.Info.module.scss';

export type EventInfoProps = {
  show?: boolean;
  eventName?: string;
  authorName?: string;
  startDate?: Date;
};

const variants: Variants = {
  enter: () => ({ y: -200, opacity: 0 }),
  center: { y: 0, opacity: 1 },
  exit: () => ({ y: -200, opacity: 0 })
};

const transition: Transition = {
  y: { type: 'spring', stiffness: 150, damping: 20, mass: 1 },
  opacity: { duration: 0.3 }
};

const Duration = memo<{ startDate?: Date }>(({ startDate }) => {
  const [value, setValue] = useState(() => getDuration(startDate));

  useEffect(() => {
    const countUpIntervalId = setInterval(() => {
      setValue(() => getDuration(startDate));
    }, 1000);

    return () => {
      clearInterval(countUpIntervalId);
    };
  }, []);

  return (
    <span className={styles.duration}>
      <LiveWaveIcon />
      <span>{displayDuration(value)}</span>
    </span>
  );
});

const EventInfo = ({ show = false, eventName, authorName, startDate }: EventInfoProps) => (
  <AnimatePresence initial={false}>
    {show && (
      <motion.div
        className={styles.container}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={transition}
      >
        <div className={styles.content}>
          <ul className={styles.list}>
            <li>
              <p className={styles.item}>
                Topic: <b>{eventName}</b>
              </p>
            </li>
            <li>
              <p className={styles.item}>
                Hosted by: <b>{authorName}</b>
              </p>
            </li>

            {startDate && (
              <li>
                <p className={styles.item}>
                  Duration:{' '}
                  <b>
                    <Duration startDate={startDate} />
                  </b>
                </p>
              </li>
            )}
          </ul>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default EventInfo;
